import React, { forwardRef } from 'react'

import { IconProps } from './types'

const Earth = forwardRef<SVGSVGElement, IconProps>(
  ({ size, ...props }, ref) => (
    <svg
      ref={ref}
      width={props.width ?? size}
      height={props.height ?? size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6666 7.99992C14.6666 11.6818 11.6818 14.6666 7.99998 14.6666C4.31808 14.6666 1.33331 11.6818 1.33331 7.99992C1.33331 4.31802 4.31808 1.33325 7.99998 1.33325C11.6818 1.33325 14.6666 4.31802 14.6666 7.99992ZM10.0013 11.3333L10.668 9.99992L8.70265 8.67925L7.40731 8.59659L6.66798 9.33325L8.00131 11.3333H10.0013ZM6.00413 6.00322L5.33413 7.33318L3.18162 5.70993C4.03847 3.91037 5.87382 2.66659 7.99965 2.66659C8.44691 2.66659 8.88125 2.72163 9.29631 2.82531L8.66745 5.33322L6.00413 6.00322Z"
        fill="currentColor"
      />
    </svg>
  ),
)
Earth.displayName = 'Earth'

export default Earth
